export const AVATAR_VARIANTS = ['green', 'yellow', 'blue', 'purple']

export const MAX_COMMENT_LENGTH = 1200
